import {Component, ElementRef, EventEmitter, Input, OnInit, OnDestroy, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import * as L from 'leaflet';
import {IrisShape} from '@models/city';
import {HttpClient} from '@angular/common/http';
import {environment} from '~/environments/environment';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

const STORAGE_KEY = 'lybox_prix_moyen_view';

// Fix Leaflet default icon paths (broken by webpack)
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'assets/marker-icon-2x.png',
    iconUrl: 'assets/marker-icon.png',
    shadowUrl: 'assets/marker-shadow.png',
});

// Palette RdYlGn (vert = pas cher, rouge = cher)
const COLOR_STOPS = [
    {pos: 0, r: 26, g: 150, b: 65},
    {pos: 0.15, r: 109, g: 184, b: 74},
    {pos: 0.30, r: 166, g: 217, b: 106},
    {pos: 0.45, r: 208, g: 236, b: 106},
    {pos: 0.55, r: 254, g: 224, b: 139},
    {pos: 0.70, r: 253, g: 174, b: 97},
    {pos: 0.85, r: 244, g: 109, b: 67},
    {pos: 1, r: 215, g: 48, b: 39},
];

@Component({
    selector: 'app-prix-moyen',
    templateUrl: './prix-moyen.component.html',
    styleUrls: ['./prix-moyen.component.scss']
})
export class PrixMoyenComponent implements OnInit, OnDestroy {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    @Output() favoriteChange = new EventEmitter();

    user: User = Object.assign({}, EMPTY_USER);

    // Adresse (localisation du point sur la carte)
    adress = '';
    adressNotFound = false;
    private adressSearch = new Subject<void>();

    advice_price_choice = '';
    advice_price = 0;
    advice_price_L = 0;
    advice_price_U = 0;
    advice_price_cL = 0;

    secteur = '';
    iris = '';

    priceChoice = {};

    // View toggle
    viewMode: 'carte' | 'graph' = 'carte';

    // Chart
    echartsIntance = null;
    chartOptions = {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: params => {
                var lib = '';
                if (params[0].name === 'Votre projet') {
                    let tot = 0;
                    params.forEach(d => {
                        if (d.seriesName == 'Travaux' || d.seriesName == 'Notaire' || d.seriesName == 'Votre projet') {
                            tot += Math.round(d.data);
                        }
                    });
                    lib += 'Votre projet : ' + Math.round(tot).toLocaleString('fr-FR') + ' €/m²<br/>';
                    params.forEach(d => {
                        if (d.seriesName == 'Travaux' || d.seriesName == 'Notaire' || d.seriesName == 'Votre projet') {
                            lib += ' • ' + (d.seriesName == 'Votre projet' ? 'Achat' : d.seriesName) + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' €/m²<br/>';
                        }
                    });
                } else {
                    params.forEach(d => {
                        if (d.seriesName != '' && d.seriesName != 'Travaux' && d.seriesName != 'Notaire' && d.seriesName != 'Votre projet' && d.data > 0) {
                            lib += d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' €/m²<br/>';
                        }
                    });
                }
                return lib;
            }
        },
        legend: { show: true, orient: 'vertical', right: '0px', top: '15px', align: 'right', data: [] },
        grid: { left: '0%', right: '4%', top: '40px', bottom: '15', containLabel: true },
        xAxis: { type: 'value', boundaryGap: [0, 0.01] },
        yAxis: { type: 'category', data: [] },
        color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],
        series: []
    };
    chartData = null;

    // Map
    private map: L.Map;
    private gqLayer: L.LayerGroup;
    private irisLayer: L.LayerGroup;
    private locationLayer: L.LayerGroup;
    private legendControl: L.Control;
    private zoomThreshold: number;
    private gqNames: { [code: string]: string } = {};
    private irisToGq: { [irisCode: string]: string } = {};
    private gqShapes: { [gqCode: string]: IrisShape[] } = {};
    private mapInitialized = false;
    private pendingFocus: L.LatLngExpression = null;

    constructor(
        private el: ElementRef,
        private http: HttpClient,
        public cityService: CityService,
        public adService: AdService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }

        if (this.advice_price_choice != "city.prix_commune.P"
            && this.advice_price_choice != "city.prix_commune.I"
        ) {
            this.advice_price_choice = this.advice_price_choice.replace('_gq', '');
            this.advice_price_choice = this.advice_price_choice.replace('_iris', '');
            if (this.iris.length == 7) {
                let s = this.advice_price_choice.split('.');
                this.advice_price_choice = s[0] + '.' + s[1] + '_gq.' + s[2];
            } else if (this.iris.length > 7) {
                let s = this.advice_price_choice.split('.');
                this.advice_price_choice = s[0] + '.' + s[1] + '_iris.' + s[2];
            }
        }

        // No emit to not save this modification
        let p = this.cityService.getPriceValue(this.favorite.ad_city, this.advice_price_choice, this.iris);
        if (p) {
            this.advice_price = p.pM;
            this.advice_price_L = p.q25;
            this.advice_price_U = p.q75;
            this.advice_price_cL = p.cL;
        }

        this.setData();
    }

    initData() {
        this.adress = this.favorite.adress || this.favorite.ad?.adress || '';
        this.iris = this.favorite.iris;
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
        }
        this.advice_price_choice = this.favorite.advice_price_real;

        if (this.advice_price_choice == 'city.prix_commune.I') {
            this.advice_price_choice = 'city.prix_commune.A';
        }
        this.advice_price = this.favorite.advice_price;
        this.advice_price_L = this.favorite.advice_price_L;
        this.advice_price_U = this.favorite.advice_price_U;
        this.advice_price_cL = this.favorite.advice_price_cL;

        this.edit(null);
    }

    ngOnInit() {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'graph' || saved === 'carte') {
            this.viewMode = saved;
        }
        this.initData();
        this.extChange.subscribe(data => {
            this.initData();
            if (this.viewMode === 'carte') {
                this.resetMap();
            }
        });
        this.adressSearch.pipe(debounceTime(400)).subscribe(() => this.searchAdress());
        this.user = this.authenticationService.currentUser;
        if (!this.preview && this.viewMode === 'carte') {
            setTimeout(() => this.initMap(), 500);
        }
    }

    ngOnDestroy() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
    }

    // ── Adresse ──

    private isFavorite(): boolean {
        return this.favorite.id !== '' && this.favorite.id != null;
    }

    editAdress() {
        this.adressNotFound = false;
        this.adressSearch.next();
    }

    private searchAdress() {
        if (this.adress.length <= 10) {
            return;
        }
        this.http.post<any>(environment.apiUrl + 'app/search_iris', {
            address: this.adress,
            city_code: this.favorite.ad_city.city_code
        }).subscribe(result => {
            this.adressNotFound = false;
            this.favorite.adress = this.adress;
            this.favorite.latitude = result.latitude;
            this.favorite.longitude = result.longitude;
            this.favorite.exact_adresse = true;

            this.pendingFocus = [result.latitude, result.longitude];
            this.focusLocation();

            // Sur un favori, l'adresse est enregistrée ; dans Tools, le point est seulement affiché
            if (this.isFavorite()) {
                this.favorite = this.adService.cleanInput(this.favorite);
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        }, error => {
            this.adressNotFound = true;
        });
    }

    private focusLocation() {
        const coords = this.getCoords();
        if (!this.map || !this.locationLayer || !coords) {
            return;
        }
        this.locationLayer.clearLayers();
        this.drawLocation();
        this.map.setView([coords.lat, coords.lng], 16);
        this.pendingFocus = null;
    }

    switchView(mode: 'carte' | 'graph') {
        if (this.viewMode === mode) return;
        if (this.viewMode === 'carte' && this.map) {
            this.map.remove();
            this.map = null;
            this.mapInitialized = false;
        }
        this.viewMode = mode;
        localStorage.setItem(STORAGE_KEY, this.viewMode);
        if (this.viewMode === 'carte') {
            setTimeout(() => this.initMap(), 500);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }

    setData() {
        this.priceChoice = this.cityService.getPriceChoice(this.favorite.ad_city, this.iris);
        delete (this.priceChoice['Général']['city.prix_commune.I']);
        delete (this.priceChoice['Général']['city.prix_commune_gq.I']);
        delete (this.priceChoice['Général']['city.prix_commune_iris.I']);

        this.updateMapZones();
        this.setChartData();
    }

    private setChartData() {
        const city = this.favorite.ad_city;
        this.chartOptions.legend.data = ['Appartement à ' + city.name, 'Maison à ' + city.name];
        this.chartOptions.yAxis.data = ['Tout confondu', (this.deviceService.isMobile() ? '1 pièce' : '1 pièce / Studio'), '2 pièces', '3 pièces', '4 pièces', '5 pièces'];

        this.chartData = {
            series: [
                {
                    name: 'Appartement à ' + city.name, type: 'bar',
                    data: [
                        city.prix_commune.A ? city.prix_commune.A.pM : null,
                        city.prix_commune_nb_piece.A && city.prix_commune_nb_piece.A[1] ? city.prix_commune_nb_piece.A[1].pM : null,
                        city.prix_commune_nb_piece.A && city.prix_commune_nb_piece.A[2] ? city.prix_commune_nb_piece.A[2].pM : null,
                        city.prix_commune_nb_piece.A && city.prix_commune_nb_piece.A[3] ? city.prix_commune_nb_piece.A[3].pM : null,
                        city.prix_commune_nb_piece.A && city.prix_commune_nb_piece.A[4] ? city.prix_commune_nb_piece.A[4].pM : null,
                        city.prix_commune_nb_piece.A && city.prix_commune_nb_piece.A[5] ? city.prix_commune_nb_piece.A[5].pM : null,
                    ]
                },
                { name: '', type: 'bar', data: [undefined, undefined, undefined, undefined, undefined, undefined, undefined] },
                {
                    name: 'Maison à ' + city.name, type: 'bar',
                    data: [
                        city.prix_commune.M ? city.prix_commune.M.pM : null,
                        city.prix_commune_nb_piece.M && city.prix_commune_nb_piece.M[1] ? city.prix_commune_nb_piece.M[1].pM : null,
                        city.prix_commune_nb_piece.M && city.prix_commune_nb_piece.M[2] ? city.prix_commune_nb_piece.M[2].pM : null,
                        city.prix_commune_nb_piece.M && city.prix_commune_nb_piece.M[3] ? city.prix_commune_nb_piece.M[3].pM : null,
                        city.prix_commune_nb_piece.M && city.prix_commune_nb_piece.M[4] ? city.prix_commune_nb_piece.M[4].pM : null,
                        city.prix_commune_nb_piece.M && city.prix_commune_nb_piece.M[5] ? city.prix_commune_nb_piece.M[5].pM : null,
                    ]
                },
                { name: '', type: 'bar', data: [undefined, undefined, undefined, undefined, undefined, undefined, undefined] },
            ]
        };

        if (this.iris.length == 7) {
            const qName = this.cityService.getQuartierName(this.advice_price_choice, city, this.iris);
            this.chartOptions.legend.data = [
                'Appartement à ' + city.name, 'Appartement du secteur "' + qName + '"',
                'Maison à ' + city.name, 'Maison du secteur "' + qName + '"'];
            this.chartData.series = [
                this.chartData.series[0],
                {
                    name: 'Appartement du secteur "' + qName + '"', type: 'bar',
                    data: [
                        city.prix_commune_gq[this.iris] && city.prix_commune_gq[this.iris].A ? city.prix_commune_gq[this.iris].A.pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].A && city.prix_commune_nb_piece_gq[this.iris].A[1] ? city.prix_commune_nb_piece_gq[this.iris].A[1].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].A && city.prix_commune_nb_piece_gq[this.iris].A[2] ? city.prix_commune_nb_piece_gq[this.iris].A[2].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].A && city.prix_commune_nb_piece_gq[this.iris].A[3] ? city.prix_commune_nb_piece_gq[this.iris].A[3].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].A && city.prix_commune_nb_piece_gq[this.iris].A[4] ? city.prix_commune_nb_piece_gq[this.iris].A[4].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].A && city.prix_commune_nb_piece_gq[this.iris].A[5] ? city.prix_commune_nb_piece_gq[this.iris].A[5].pM : null,
                    ]
                },
                this.chartData.series[2],
                {
                    name: 'Maison du secteur "' + qName + '"', type: 'bar',
                    data: [
                        city.prix_commune_gq[this.iris] && city.prix_commune_gq[this.iris].M ? city.prix_commune_gq[this.iris].M.pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].M && city.prix_commune_nb_piece_gq[this.iris].M[1] ? city.prix_commune_nb_piece_gq[this.iris].M[1].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].M && city.prix_commune_nb_piece_gq[this.iris].M[2] ? city.prix_commune_nb_piece_gq[this.iris].M[2].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].M && city.prix_commune_nb_piece_gq[this.iris].M[3] ? city.prix_commune_nb_piece_gq[this.iris].M[3].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].M && city.prix_commune_nb_piece_gq[this.iris].M[4] ? city.prix_commune_nb_piece_gq[this.iris].M[4].pM : null,
                        city.prix_commune_nb_piece_gq[this.iris].M && city.prix_commune_nb_piece_gq[this.iris].M[5] ? city.prix_commune_nb_piece_gq[this.iris].M[5].pM : null,
                    ]
                }
            ];
        }

        if (this.iris.length > 7) {
            const qName = this.cityService.getQuartierName(this.advice_price_choice, city, this.iris);
            this.chartOptions.legend.data = [
                'Appartement à ' + city.name, 'Appartement du quartier "' + qName + '"',
                'Maison à ' + city.name, 'Maison du quartier "' + qName + '"'];
            this.chartData.series = [
                this.chartData.series[0],
                {
                    name: 'Appartement du quartier "' + qName + '"', type: 'bar',
                    data: [
                        city.prix_commune_iris[this.iris] && city.prix_commune_iris[this.iris].A ? city.prix_commune_iris[this.iris].A.pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].A && city.prix_commune_nb_piece_iris[this.iris].A[1] ? city.prix_commune_nb_piece_iris[this.iris].A[1].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].A && city.prix_commune_nb_piece_iris[this.iris].A[2] ? city.prix_commune_nb_piece_iris[this.iris].A[2].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].A && city.prix_commune_nb_piece_iris[this.iris].A[3] ? city.prix_commune_nb_piece_iris[this.iris].A[3].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].A && city.prix_commune_nb_piece_iris[this.iris].A[4] ? city.prix_commune_nb_piece_iris[this.iris].A[4].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].A && city.prix_commune_nb_piece_iris[this.iris].A[5] ? city.prix_commune_nb_piece_iris[this.iris].A[5].pM : null,
                    ]
                },
                this.chartData.series[2],
                {
                    name: 'Maison du quartier "' + qName + '"', type: 'bar',
                    data: [
                        city.prix_commune_iris[this.iris] && city.prix_commune_iris[this.iris].M ? city.prix_commune_iris[this.iris].M.pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].M && city.prix_commune_nb_piece_iris[this.iris].M[1] ? city.prix_commune_nb_piece_iris[this.iris].M[1].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].M && city.prix_commune_nb_piece_iris[this.iris].M[2] ? city.prix_commune_nb_piece_iris[this.iris].M[2].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].M && city.prix_commune_nb_piece_iris[this.iris].M[3] ? city.prix_commune_nb_piece_iris[this.iris].M[3].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].M && city.prix_commune_nb_piece_iris[this.iris].M[4] ? city.prix_commune_nb_piece_iris[this.iris].M[4].pM : null,
                        city.prix_commune_nb_piece_iris[this.iris] && city.prix_commune_nb_piece_iris[this.iris].M && city.prix_commune_nb_piece_iris[this.iris].M[5] ? city.prix_commune_nb_piece_iris[this.iris].M[5].pM : null,
                    ]
                }
            ];
        }

        if (this.favorite.id !== '') {
            this.chartOptions.legend.data.push('Votre projet');
            this.chartOptions.yAxis.data.push('Votre projet');
            this.chartData.series.push({
                name: 'Votre projet', type: 'bar', stack: '1',
                data: [undefined, undefined, undefined, undefined, undefined, undefined, (this.favorite.price / this.favorite.square).toPrecision(4)]
            });
            this.chartData.series.push({
                name: 'Notaire', type: 'bar', stack: '1',
                data: [undefined, undefined, undefined, undefined, undefined, undefined, (this.favorite.notary_price / this.favorite.square).toPrecision(4)]
            });
            this.chartData.series.push({
                name: 'Travaux', type: 'bar', stack: '1',
                data: [undefined, undefined, undefined, undefined, undefined, undefined, (this.favorite.works_total / this.favorite.square).toPrecision(4)]
            });
        }

        if (this.deviceService.isMobile()) {
            this.chartOptions.grid.top = '35%';
            this.chartOptions.grid.right = '0px';
            this.chartOptions.legend.orient = 'horizontal';
            this.chartOptions.legend.right = 'auto';
            this.chartOptions.legend.align = 'auto';
        }

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.chartOptions);
        }
    }

    // ── Map logic ──

    private updateMapZones() {
        if (!this.map || !this.gqLayer || !this.irisLayer) {
            return;
        }
        this.gqLayer.clearLayers();
        this.irisLayer.clearLayers();
        this.drawZones();
        this.locationLayer.clearLayers();
        this.drawLocation();
    }

    private resetMap() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
        this.gqNames = {};
        this.irisToGq = {};
        this.gqShapes = {};
        this.legendControl = null;
        this.mapInitialized = false;
        setTimeout(() => this.initMap(), 500);
    }

    private parseCoord(coord: any): any {
        try {
            const parsed = typeof coord === 'string' ? JSON.parse(coord) : coord;
            const ring = parsed?.coordinates?.[0];
            if (Array.isArray(ring) && ring.length > 2 && Array.isArray(ring[0]) && isFinite(ring[0][0])) {
                return parsed;
            }
            return null;
        } catch {
            return null;
        }
    }

    private initMap() {
        const shapes = this.favorite?.ad_city?.iris_shapes;
        if (!shapes || shapes.length === 0) {
            return;
        }

        const container = this.el.nativeElement.querySelector('.map-container');
        if (!container) {
            return;
        }

        const center = this.getCenter();
        if (!center || (Array.isArray(center) && (!isFinite(center[0] as number) || !isFinite(center[1] as number)))) {
            return;
        }

        this.buildGqNames();
        this.buildMappings();

        this.map = L.map(container, {
            scrollWheelZoom: true,
            zoomControl: true
        }).setView(center, 13);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap'
        }).addTo(this.map);

        const singleGq = Object.keys(this.gqShapes).length <= 1;

        this.gqLayer = L.layerGroup();
        this.irisLayer = L.layerGroup();
        this.locationLayer = L.layerGroup().addTo(this.map);

        if (singleGq) {
            this.irisLayer.addTo(this.map);
        } else {
            this.gqLayer.addTo(this.map);
        }

        this.drawZones();
        this.drawLocation();
        this.fitBoundsToShapes();

        if (this.pendingFocus) {
            this.map.setView(this.pendingFocus, 16);
            this.pendingFocus = null;
        }

        // La carte peut être détruite (switchView, resetMap, ngOnDestroy) avant ces timers.
        const map = this.map;
        if (!singleGq) {
            setTimeout(() => {
                if (this.map !== map) return;
                this.zoomThreshold = map.getZoom() + 1;
                map.on('zoomend', () => this.updateLayerVisibility());
            }, 100);
        }

        setTimeout(() => {
            if (this.map === map) map.invalidateSize();
        }, 200);
        this.mapInitialized = true;
    }

    private getCoords(): { lat: number; lng: number } | null {
        const fav = this.favorite;
        if (fav && fav.latitude && fav.longitude) {
            return {lat: fav.latitude, lng: fav.longitude};
        }
        const ad = fav?.ad;
        if (ad && ad.latitude && ad.longitude) {
            return {lat: ad.latitude, lng: ad.longitude};
        }
        return null;
    }

    private isExactAdresse(): boolean {
        if (this.favorite?.exact_adresse) {
            return true;
        }
        return this.favorite?.ad?.exact_adresse || false;
    }

    private getRadiusLocation(): number {
        return this.favorite?.ad?.radius_location || 1000;
    }

    private getCenterFromShapes(): L.LatLngExpression {
        const shapes = this.favorite?.ad_city?.iris_shapes;
        if (shapes && shapes.length > 0) {
            let totalLat = 0, totalLng = 0, count = 0;
            shapes.forEach(shape => {
                const geojson = this.parseCoord(shape.coord);
                if (!geojson) return;
                geojson.coordinates[0].forEach((c: number[]) => {
                    if (Array.isArray(c) && isFinite(c[0]) && isFinite(c[1])) {
                        totalLng += c[0];
                        totalLat += c[1];
                        count++;
                    }
                });
            });
            if (count > 0) {
                return [totalLat / count, totalLng / count];
            }
        }
        return null;
    }

    private getCenter(): L.LatLngExpression {
        const shapeCenter = this.getCenterFromShapes();
        if (shapeCenter) {
            return shapeCenter;
        }
        const coords = this.getCoords();
        if (coords) {
            return [coords.lat, coords.lng];
        }
        return null;
    }

    private buildGqNames() {
        const mapping = this.favorite.ad_city?.mapping_quartier_iris;
        if (mapping && mapping.quartier) {
            mapping.quartier.forEach(gq => {
                this.gqNames[gq.GQ_c] = gq.GQ_n;
            });
        }
    }

    private buildMappings() {
        const shapes = this.favorite?.ad_city?.iris_shapes;
        const mapping = this.favorite.ad_city?.mapping_quartier_iris;

        if (mapping && mapping.quartier) {
            mapping.quartier.forEach(gq => {
                if (gq.iris) {
                    gq.iris.forEach(iris => {
                        this.irisToGq[iris.IRIS_c] = gq.GQ_c;
                    });
                }
            });
        }

        if (shapes) {
            shapes.forEach(shape => {
                const gqCode = this.irisToGq[shape.id] || 'unknown';
                if (!this.gqShapes[gqCode]) {
                    this.gqShapes[gqCode] = [];
                }
                this.gqShapes[gqCode].push(shape);
            });
        }
    }

    private getPropertyPriceM2(): number {
        const price = this.favorite?.price || this.favorite?.ad?.price;
        const square = this.favorite?.square || this.favorite?.ad?.square;
        if (price && square && square > 0) {
            return Math.round(price / square);
        }
        return 0;
    }

    private drawLocation() {
        const ad = this.favorite?.ad;
        const coords = this.getCoords();

        if (coords) {
            const latlng: L.LatLngExpression = [coords.lat, coords.lng];
            const adresse = this.favorite.adress || ad?.adress || '';
            const priceM2 = this.getPropertyPriceM2();
            const priceLine = priceM2 > 0 ? `<br>Prix au m² de votre projet : <strong>${priceM2.toLocaleString('fr-FR')} €/m²</strong>` : '';

            if (this.isExactAdresse()) {
                const tooltipContent = adresse
                    ? `<strong>Emplacement du bien : </strong>${adresse}${priceLine}`
                    : `<strong>Emplacement du bien</strong>${priceLine}`;
                L.marker(latlng)
                    .addTo(this.locationLayer)
                    .bindTooltip(tooltipContent, {direction: 'top'});
            } else {
                const radius = this.getRadiusLocation();
                const tooltipContent = adresse
                    ? `<strong>Zone approximative : </strong>${adresse}${priceLine}`
                    : `<strong>Zone approximative du bien</strong>${priceLine}`;
                L.circle(latlng, {
                    radius,
                    color: '#3388ff',
                    fillColor: '#3388ff',
                    fillOpacity: 0.15,
                    weight: 2
                }).addTo(this.locationLayer)
                    .bindTooltip(tooltipContent, {direction: 'top'});
            }
        }
    }

    private priceToColor(ratio: number): string {
        const t = Math.max(0, Math.min(1, ratio));
        let lower = COLOR_STOPS[0];
        let upper = COLOR_STOPS[COLOR_STOPS.length - 1];
        for (let i = 0; i < COLOR_STOPS.length - 1; i++) {
            if (t >= COLOR_STOPS[i].pos && t <= COLOR_STOPS[i + 1].pos) {
                lower = COLOR_STOPS[i];
                upper = COLOR_STOPS[i + 1];
                break;
            }
        }
        const range = upper.pos - lower.pos || 1;
        const local = (t - lower.pos) / range;
        const r = Math.round(lower.r + (upper.r - lower.r) * local);
        const g = Math.round(lower.g + (upper.g - lower.g) * local);
        const b = Math.round(lower.b + (upper.b - lower.b) * local);
        return `rgb(${r}, ${g}, ${b})`;
    }

    private formatPrice(val: number): string {
        return val > 0 ? Math.round(val).toLocaleString('fr-FR') + ' €' : '';
    }

    private getBaseKey(): string {
        return this.advice_price_choice.replace('_gq', '').replace('_iris', '');
    }

    private getTooltipLabel(): string {
        const baseKey = this.getBaseKey();
        const field = this.cityService.priceFields[baseKey];
        return field ? field.lib : 'Prix moyen au m²';
    }

    private getZonePrice(zoneCode: string, level: 'gq' | 'iris'): number {
        const baseKey = this.getBaseKey();
        const parts = baseKey.split('.');
        parts[1] = parts[1] + '_' + level;
        const key = parts.join('.');
        const p = this.cityService.getPriceValue(this.favorite.ad_city, key, zoneCode);
        return p?.pM || 0;
    }

    private updateLegend(priceMin: number, priceMax: number) {
        if (this.legendControl) {
            this.map.removeControl(this.legendControl);
        }

        const minLabel = this.formatPrice(priceMin);
        const maxLabel = this.formatPrice(priceMax);

        const LegendControl = L.Control.extend({
            onAdd: () => {
                const div = L.DomUtil.create('div', 'iris-legend');
                div.innerHTML = `
                    <span>${minLabel}</span>
                    <div class="iris-legend-gradient"></div>
                    <span>${maxLabel}</span>
                `;
                return div;
            }
        });

        this.legendControl = new LegendControl({position: 'topright'});
        this.legendControl.addTo(this.map);
    }

    private getCommunePrice(): number {
        const baseKey = this.getBaseKey();
        const p = this.cityService.getPriceValue(this.favorite.ad_city, baseKey, '');
        return p?.pM || 0;
    }

    private drawZones() {
        const shapes = this.favorite?.ad_city?.iris_shapes;
        if (!shapes || shapes.length === 0) {
            return;
        }

        const tooltipLabel = this.getTooltipLabel();

        const allPrices: number[] = [];
        Object.keys(this.gqShapes).forEach(gqCode => {
            const p = this.getZonePrice(gqCode, 'gq');
            if (p > 0) allPrices.push(p);
        });
        shapes.forEach(shape => {
            const p = this.getZonePrice(shape.id, 'iris');
            if (p > 0) allPrices.push(p);
        });

        const communePrice = this.getCommunePrice();
        const useCommuneFallback = allPrices.length === 0 && communePrice > 0;
        if (useCommuneFallback) {
            allPrices.push(communePrice);
        }

        if (allPrices.length === 0) {
            this.drawShapesWithoutPrices(shapes, tooltipLabel);
            if (this.legendControl) {
                this.map.removeControl(this.legendControl);
                this.legendControl = null;
            }
            return;
        }

        const priceMin = Math.min(...allPrices);
        const priceMax = Math.max(...allPrices);

        this.updateLegend(priceMin, priceMax);

        // Draw GQ layer
        Object.keys(this.gqShapes).forEach(gqCode => {
            const gqName = this.gqNames[gqCode] || gqCode;
            let priceVal = this.getZonePrice(gqCode, 'gq');
            if (!priceVal && useCommuneFallback) priceVal = communePrice;

            let color = '#ccc';
            if (priceVal > 0 && priceMax > priceMin) {
                color = this.priceToColor((priceVal - priceMin) / (priceMax - priceMin));
            } else if (priceVal > 0) {
                color = this.priceToColor(0.5);
            }

            const priceLabel = priceVal > 0
                ? `<br>${tooltipLabel} : <strong>${this.formatPrice(priceVal)}/m²</strong>`
                : '<br><em>Volume de ventes insuffisant<br>pour ce type de bien</em>';

            this.gqShapes[gqCode].forEach(shape => {
                const geojson = this.parseCoord(shape.coord);
                if (!geojson) return;
                const coords = geojson.coordinates[0].map((c: number[]) => [c[1], c[0]] as L.LatLngExpression);
                L.polygon(coords, {
                    color: color,
                    fillColor: color,
                    fillOpacity: 0.55,
                    weight: 0
                }).addTo(this.gqLayer)
                    .bindTooltip(`<strong>${gqName}</strong>${priceLabel}`, {sticky: true});
            });

            // Contour extérieur du GQ
            const edgeCounts: { [key: string]: number } = {};
            const edgeCoords: { [key: string]: [L.LatLngExpression, L.LatLngExpression] } = {};

            this.gqShapes[gqCode].forEach(shape => {
                const geojson = this.parseCoord(shape.coord);
                if (!geojson) return;
                const rawCoords: number[][] = geojson.coordinates[0];
                for (let i = 0; i < rawCoords.length - 1; i++) {
                    const a = rawCoords[i];
                    const b = rawCoords[i + 1];
                    const keyAB = `${a[0]},${a[1]}|${b[0]},${b[1]}`;
                    const keyBA = `${b[0]},${b[1]}|${a[0]},${a[1]}`;

                    if (edgeCounts[keyBA]) {
                        edgeCounts[keyBA]++;
                    } else {
                        edgeCounts[keyAB] = (edgeCounts[keyAB] || 0) + 1;
                        edgeCoords[keyAB] = [[a[1], a[0]], [b[1], b[0]]];
                    }
                }
            });

            Object.keys(edgeCounts).forEach(key => {
                if (edgeCounts[key] === 1) {
                    L.polyline(edgeCoords[key], {
                        color: '#aaa',
                        weight: 1.5
                    }).addTo(this.gqLayer);
                }
            });
        });

        // Draw IRIS layer
        shapes.forEach(shape => {
            const geojson = this.parseCoord(shape.coord);
            if (!geojson) return;
            const coords = geojson.coordinates[0].map((c: number[]) => [c[1], c[0]] as L.LatLngExpression);
            let priceVal = this.getZonePrice(shape.id, 'iris');
            if (!priceVal && useCommuneFallback) priceVal = communePrice;

            let color = '#ccc';
            if (priceVal > 0 && priceMax > priceMin) {
                color = this.priceToColor((priceVal - priceMin) / (priceMax - priceMin));
            } else if (priceVal > 0) {
                color = this.priceToColor(0.5);
            }

            const priceLabel = priceVal > 0
                ? `<br>${tooltipLabel} : <strong>${this.formatPrice(priceVal)}/m²</strong>`
                : '<br><em>Volume de ventes insuffisant<br>pour ce type de bien</em>';

            L.polygon(coords, {
                color: '#aaa',
                fillColor: color,
                fillOpacity: 0.55,
                weight: 1.5
            }).addTo(this.irisLayer)
                .bindTooltip(`<strong>${shape.name}</strong>${priceLabel}`, {sticky: true});
        });
    }

    private drawShapesWithoutPrices(shapes: IrisShape[], label: string) {
        shapes.forEach(shape => {
            const geojson = this.parseCoord(shape.coord);
            if (!geojson) return;
            const coords = geojson.coordinates[0].map((c: number[]) => [c[1], c[0]] as L.LatLngExpression);
            L.polygon(coords, {
                color: '#aaa',
                fillColor: '#ccc',
                fillOpacity: 0.3,
                weight: 1.5
            }).addTo(this.gqLayer)
                .bindTooltip(`<strong>${shape.name}</strong><br><em>Volume de ventes insuffisant<br>pour ce type de bien</em>`, {sticky: true});
            L.polygon(coords, {
                color: '#aaa',
                fillColor: '#ccc',
                fillOpacity: 0.3,
                weight: 1.5
            }).addTo(this.irisLayer)
                .bindTooltip(`<strong>${shape.name}</strong><br><em>Volume de ventes insuffisant<br>pour ce type de bien</em>`, {sticky: true});
        });
    }

    private fitBoundsToShapes() {
        const shapes = this.favorite?.ad_city?.iris_shapes;
        if (!shapes || shapes.length === 0) {
            return;
        }

        const allCoords: L.LatLngExpression[] = [];
        shapes.forEach(shape => {
            const geojson = this.parseCoord(shape.coord);
            if (!geojson) return;
            geojson.coordinates[0].forEach((c: number[]) => {
                const lat = c[1];
                const lng = c[0];
                if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180 && (lat !== 0 || lng !== 0)) {
                    allCoords.push([lat, lng]);
                }
            });
        });

        if (allCoords.length > 0) {
            const bounds = L.latLngBounds(allCoords);
            if (bounds.isValid()) {
                this.map.fitBounds(bounds, {padding: [20, 20], maxZoom: 16});
            }
        }
    }

    private updateLayerVisibility() {
        const zoom = this.map.getZoom();
        if (zoom >= this.zoomThreshold) {
            if (!this.map.hasLayer(this.irisLayer)) {
                this.irisLayer.addTo(this.map);
            }
            if (this.map.hasLayer(this.gqLayer)) {
                this.map.removeLayer(this.gqLayer);
            }
        } else {
            if (!this.map.hasLayer(this.gqLayer)) {
                this.gqLayer.addTo(this.map);
            }
            if (this.map.hasLayer(this.irisLayer)) {
                this.map.removeLayer(this.irisLayer);
            }
        }
        this.locationLayer.eachLayer(layer => {
            if ((layer as any).bringToFront) {
                (layer as any).bringToFront();
            }
        });
    }
}
